import { render, staticRenderFns } from "./AcceptUnacceptedView.vue?vue&type=template&id=0bb0ba79&"
import script from "./AcceptUnacceptedView.vue?vue&type=script&lang=js&"
export * from "./AcceptUnacceptedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports